import React from 'react';

function Privacy() {
  return (
    <div className="center-container">
      <div className="card">
        <h1>Privacy Policy</h1>
        <p style={{ color: '#666' }}>Coming soon.</p>
      </div>
    </div>
  );
}

export default Privacy;
